<template>
    <div class="health-title">
        <div class="he-1">
            <div class="he-2">
                <div>
                    <el-upload
                        class="avatar-uploader1"
                        disabled
                        action="#"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload"
                    >
                        <img
                            v-if="data.photo"
                            :src="data.photo"
                            class="avatar1"
                        />
                        <i
                            v-else
                            class="el-icon-plus avatar-uploader-icon1"
                        ></i>
                    </el-upload>
                    <div class="shangchuang1">健康指数</div>
                </div>
            </div>
            <div class="he-3">
                <div>{{ data.customerName }}</div>
                <div class="he-3-1">
                    <div>性别：</div>
                    <div>{{ data.gender == 1 ? "女" : "男" }}</div>
                </div>
                <div class="he-3-1">
                    <div>年龄：</div>
                    <div>{{ data.age }}</div>
                </div>
                <div class="he-3-1">
                    <div>电话：</div>
                    <div>{{ data.phone }}</div>
                </div>
            </div>
            <div class="he-3-3">
                <div style="height: 16px"></div>
                <div class="he-3-2">
                    <div>出生年月：</div>
                    <div>{{ data.birthday }}</div>
                </div>
                <div class="he-3-2">
                    <div>身份证号：</div>
                    <div class="he-3-4">{{ data.idCard }}</div>
                </div>
                <div class="he-3-2">
                    <div>地址：</div>
                    <div class="he-3-4" :title="data.address">
                        {{ data.address }}
                    </div>
                </div>
            </div>
            <div class="he-4-4">
                <div>
                    <div style="height: 16px"></div>
                    <div class="he-3-1">
                        <div style="line-height: 32px; margin-right: 5px">
                            身高
                        </div>
                        <div>
                            <el-input
                                @blur="wHealth"
                                v-model="addForm.height"
                                size="small"
                                :disabled="setTitle == '查看'"
                                style="width: 100px"
                            ></el-input>
                        </div>
                    </div>
                    <div class="he-3-1">
                        <div style="line-height: 32px; margin-right: 5px">
                            体重
                        </div>
                        <div>
                            <el-input
                                @blur="wHealth"
                                v-model="addForm.weight"
                                size="small"
                                :disabled="setTitle == '查看'"
                                style="width: 100px"
                            ></el-input>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="height: 4px"></div>
        <div class="health-1 border-bottom border-top border-left border-right">
            <div class="border-right">病史</div>
            <div>
                <el-checkbox-group @change="changeDisease" v-model="diseaseId">
                    <el-checkbox label="健康">健康</el-checkbox>
                    <el-checkbox label="高血压">高血压</el-checkbox>
                    <el-checkbox label="糖尿病">糖尿病</el-checkbox>
                    <el-checkbox label="冠心病">冠心病</el-checkbox>
                    <el-checkbox label="恶性肿瘤">恶性肿瘤</el-checkbox>
                    <el-checkbox label="结核病">结核病</el-checkbox>
                    <el-checkbox label="肝炎">肝炎</el-checkbox>
                    <el-checkbox label="脑卒中">脑卒中</el-checkbox>
                    <el-checkbox label="精神疾病">精神疾病</el-checkbox>
                    <el-checkbox label="慢性阻塞性肺疾病"
                        >慢性阻塞性肺疾病</el-checkbox
                    >
                    <el-checkbox label="慢性支气管炎">慢性支气管炎</el-checkbox>
                    <el-checkbox label="帕金森综合症">帕金森综合症</el-checkbox>
                    <el-checkbox label="腰椎间盘突出">腰椎间盘突出</el-checkbox>
                    <el-checkbox label="阿尔茨海默病">阿尔茨海默病</el-checkbox>
                </el-checkbox-group>
            </div>
        </div>

        <div class="health-2 border-bottom border-left border-right">
            <div class="border-right">自理类别</div>
            <div>
                <el-radio-group
                    @blur="wHealth"
                    v-model="addForm.selfCareType"
                    :disabled="setTitle == '查看'"
                >
                    <el-radio :label="0">自理</el-radio>
                    <el-radio :label="1">失能</el-radio>
                    <el-radio :label="2">半失能</el-radio>
                    <el-radio :label="3">失智</el-radio>
                    <el-radio :label="4">轻度依赖</el-radio>
                    <el-radio :label="5">重度依赖</el-radio>
                    <el-radio :label="6">不能自理</el-radio>
                </el-radio-group>
            </div>
        </div>

        <div class="health-3 border-bottom">
            <div class="health-3-1 border-left border-right">
                <div class="border-right">经常服用药物</div>
                <div>
                    <el-input
                        @blur="wHealth"
                        v-model="addForm.regularMedicine"
                        type="textarea"
                        :rows="2"
                    ></el-input>
                </div>
            </div>
            <div class="health-3-1 border-right">
                <div class="border-right">听力情况</div>
                <div>
                    <el-radio-group
                        @blur="wHealth"
                        v-model="addForm.listen"
                        :disabled="setTitle == '查看'"
                    >
                        <el-radio :label="0">良好</el-radio>
                        <el-radio :label="1">一般</el-radio>
                        <el-radio :label="2">很大声才能听见</el-radio>
                        <el-radio :label="3">听不见</el-radio>
                    </el-radio-group>
                </div>
            </div>
        </div>

        <div class="health-3 border-bottom">
            <div class="health-4-1 border-left border-right">
                <div class="border-right">药物过敏情况</div>
                <div>
                    <el-input
                        @blur="wHealth"
                        v-model="addForm.medicineAllergy"
                        placeholder="请输入"
                    ></el-input>
                </div>
            </div>
            <div class="health-4-1 border-right">
                <div class="border-right">绑定设备(IMEI)</div>
                <div>
                    <el-input
                        @blur="wHealth"
                        v-model="addForm.bindDevice"
                        placeholder="请输入"
                    ></el-input>
                </div>
            </div>
        </div>

        <div class="health-5 border-bottom border-right">
            <div class="border-left border-right">备注</div>
            <div>
                <el-input
                    @blur="wHealth"
                    v-model="addForm.remark"
                    placeholder="请输入"
                    type="textarea"
                    :rows="2"
                ></el-input>
            </div>
        </div>

        <div class="health-6">
            <div style="padding: 0 10px; box-sizing: border-box">
                <div class="health-6-1">高血压</div>
                <el-input
                    @blur="wHealth"
                    v-model="addForm.hypertension"
                    size="small"
                    placeholder="请输入"
                    style="margin-top: 10px"
                ></el-input>
            </div>
            <div style="padding: 0 10px; box-sizing: border-box">
                <div class="health-6-1">糖尿病</div>
                <el-input
                    @blur="wHealth"
                    v-model="addForm.diabetic"
                    size="small"
                    placeholder="请输入"
                    style="margin-top: 10px"
                ></el-input>
            </div>
            <div style="padding: 0 10px; box-sizing: border-box">
                <div class="health-6-1">高血脂</div>
                <el-input
                    @blur="wHealth"
                    v-model="addForm.hyperlipidemia"
                    size="small"
                    placeholder="请输入"
                    style="margin-top: 10px"
                ></el-input>
            </div>
            <div style="padding: 0 10px; box-sizing: border-box">
                <div class="health-6-1">家族遗传史</div>
                <el-input
                    @blur="wHealth"
                    v-model="addForm.familyGeneticHistory"
                    size="small"
                    placeholder="请输入"
                    style="margin-top: 10px"
                ></el-input>
            </div>
        </div>

        <div class="health-6">
            <div style="padding: 0 10px; box-sizing: border-box">
                <div class="health-6-1">接种史</div>
                <el-input
                    @blur="wHealth"
                    v-model="addForm.vaccinationHistory"
                    size="small"
                    placeholder="请输入"
                    style="margin-top: 10px"
                ></el-input>
            </div>
            <div style="padding: 0 10px; box-sizing: border-box">
                <div class="health-6-1">过敏史</div>
                <el-input
                    @blur="wHealth"
                    v-model="addForm.allergicHistory"
                    size="small"
                    placeholder="请输入"
                    style="margin-top: 10px"
                ></el-input>
            </div>
            <div style="padding: 0 10px; box-sizing: border-box">
                <div class="health-6-1">疾病史</div>
                <el-input
                    @blur="wHealth"
                    v-model="addForm.diseaseHistory"
                    size="small"
                    placeholder="请输入"
                    style="margin-top: 10px"
                ></el-input>
            </div>
            <div style="padding: 0 10px; box-sizing: border-box">
                <div class="health-6-1">用药史</div>
                <el-input
                    @blur="wHealth"
                    v-model="addForm.medicationHistory"
                    size="small"
                    placeholder="请输入"
                    style="margin-top: 10px"
                ></el-input>
            </div>
        </div>

        <div class="health-7">
            <div>血压</div>
            <div>
                <DateLine></DateLine>
            </div>
        </div>
    </div>
</template>

<script>
import DateLine from "../graph/line.vue"
import exportVue from "@/utils/exportVue"
export default {
    props: {
        setTitle: {
            type: String,
            default: "",
        },
        formData: {},
        wHealthData: {},
    },
    components: {
        DateLine,
    },
    data() {
        return {
            imageUrl: "",
            checkList: [],
            addForm: {},
            data: {},
            diseaseId: [],
        }
    },
    watch: {
        formData: {
            handler(val) {
                if (this.formData.id) {
                    this.addForm = val.customerHealth
                    this.data = {}
                    this.data = Object.assign({}, val)
                    this.diseaseId = this.addForm.disease.split(",")
                    this.wHealth()
                } else {
                    this.addForm = {}
                    this.diseaseId = []
                    this.data = {}
                }
            },
            deep: true,
            immediate: true,
        },
    },
    created() {
        exportVue.$on("wcustomerData", (data) => {
            if (JSON.stringify(data) != "{}") {
                console.log(JSON.stringify(data) == "{}", "修改了什么")
                this.data = {}
                this.data = Object.assign({}, data)
            }
        })
    },
    methods: {
        handleAvatarSuccess(res, file) {
            this.imageUrl = URL.createObjectURL(file.raw)
        },
        beforeAvatarUpload(file) {},
        changeDisease(val) {
            this.$set(this.addForm, "disease", val.join(","))
            this.wHealth()
        },
        wHealth() {
            this.$emit("healthInfo", this.addForm)
        },
    },
}
</script>

<style lang="less" scoped>
.health-title {
    width: 98%;
    margin-left: 2%;
}

.shangchuang1 {
    width: 128px;
    height: 30px;
    line-height: 30px;
    border-radius: 5px;
    color: #ffffff;
    margin-top: 15px;
    text-align: center;
    background-color: #0000ff;
}

.he-1 {
    width: 100%;
    display: flex;
    padding: 10px 0;
    background-color: #eeeeee;
}

.he-1 > div {
    width: 25%;
}

.he-2 {
    display: flex;
    justify-content: center;
    align-items: center;
}

.he-3 {
}

.he-3-1 {
    margin-top: 20px;
    display: flex;
}

.he-3-3 {
    width: 25%;
}

.he-3-2 {
    width: 100%;
    margin-top: 20px;
    display: flex;
}

.he-3-4 {
    width: 140px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.he-4-4 {
    width: 25%;
}

.he-4-4 > div {
    margin-left: 30px;
}

.health-1 {
    width: 100%;
    display: flex;
    height: 100px;
    align-items: center;
}

.health-1 > div:first-child {
    width: 100px;
    text-align: center;
    height: 100px;
    line-height: 100px;
    background-color: #eeeeee;
}

.health-1 > div:nth-child(2) {
    margin-left: 10px;
    width: calc(100% - 110px);
}

.border-top {
    border-top: 1px solid #c0c4cc;
}

.border-right {
    border-right: 1px solid #c0c4cc;
}

.border-bottom {
    border-bottom: 1px solid #c0c4cc;
}

.border-left {
    border-left: 1px solid #c0c4cc;
}

.health-2 {
    width: 100%;
    display: flex;
    height: 50px;
    align-items: center;
}

.health-2 > div:first-child {
    width: 100px;
    text-align: center;
    height: 50px;
    line-height: 50px;
    background-color: #eeeeee;
}

.health-2 > div:nth-child(2) {
    margin-left: 10px;
    width: calc(100% - 110px);
}

.health-3 {
    width: 100%;
    display: flex;
}

.health-3-1 {
    width: 50%;
    display: flex;
    height: 80px;
    align-items: center;
}

.health-3-1 > div:first-child {
    width: 120px;
    text-align: center;
    height: 80px;
    line-height: 80px;
    background-color: #eeeeee;
}

.health-3-1 > div:nth-child(2) {
    margin-left: 10px;
    width: calc(100% - 130px);

    /deep/.el-textarea__inner {
        border: none;
        resize: none;
    }
}

.health-4-1 {
    width: 50%;
    display: flex;
    height: 40px;
    align-items: center;
}

.health-4-1 > div:first-child {
    width: 120px;
    text-align: center;
    height: 40px;
    line-height: 40px;
    background-color: #eeeeee;
}

.health-4-1 > div:nth-child(2) {
    // margin-left: 10px;
    width: calc(100% - 120px);

    /deep/.el-input__inner {
        border: none;
    }
}
.health-5 {
    width: 100%;
    display: flex;
    height: 80px;
    align-items: center;
}
.health-5 > div:first-child {
    width: 120px;
    text-align: center;
    height: 80px;
    line-height: 80px;
    background-color: #eeeeee;
}
.health-5 > div:nth-child(2) {
    width: calc(100% - 120px);

    /deep/.el-textarea__inner {
        border: none;
        resize: none;
    }
}
.health-6 {
    width: 90%;
    margin: 20px auto;
    display: flex;
    justify-content: space-between;
}
.health-6 > div {
    width: 24%;
    background-color: #eeeeee;
    height: 100px;
}
.health-6-1 {
    width: 100%;
    margin-top: 20px;
    text-align: center;
}
.health-7 {
    width: 100%;
}
.health-7 > div:first-child {
    width: 100%;
    text-align: center;
    height: 40px;
    line-height: 40px;
    background-color: #55aa7f;
    color: #ffffff;
    border-top: 2px solid #333333;
}
.health-7 > div:nth-child(2) {
    width: 100%;
    background-color: #333;
}
</style>


<style>
.avatar-uploader1 .el-upload {
    border: 1px dashed #bbbbbb;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader1 .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon1 {
    font-size: 28px;
    color: #8c939d;
    width: 128px;
    height: 128px;
    line-height: 128px;
    text-align: center;
}

.avatar1 {
    width: 128px;
    height: 128px;
    display: block;
}
</style>
